// eslint-disable-next-line no-restricted-imports
import { Formatter, query, zero } from 'fp-ts-routing';

import { iots } from '@code-expert/prelude';
import { ProjectEntryKey, ProjectId, SnapshotId } from '/imports/domain';
import type { UnwrapMatch } from '/imports/modules/Routing';
import { end, formatRoute, lit, Match, type, url } from '/imports/modules/Routing';
import { MessagesSection } from '/imports/ui/pages/myCourses/messages/navigation';

const ide2 = lit('ide2');
const projectId = type('projectId', ProjectId);
const solution = lit('solution');

const queryParams = query(
  iots.exact(
    iots.partial({
      fileKey: ProjectEntryKey,
      snapshotId: SnapshotId,
      section: MessagesSection,
    }),
  ),
);

const mainRoute = url(ide2, projectId, queryParams, end);
const solutionRoute = url(ide2, projectId, solution, queryParams, end);

export type IdeRouteParams = UnwrapMatch<typeof mainRoute> & { showSolution: boolean };

export const ideRoute: Match<IdeRouteParams> = new Match(
  zero<IdeRouteParams>()
    .alt(mainRoute.parser.map((p) => ({ ...p, showSolution: false })))
    .alt(solutionRoute.parser.map((p) => ({ ...p, showSolution: true }))),
  new Formatter((route, { showSolution, projectId, snapshotId, fileKey, section }) =>
    (showSolution ? solutionRoute.formatter : mainRoute.formatter).run(route, {
      projectId,
      fileKey,
      snapshotId,
      section,
    }),
  ),
);

export type IdeNavigationParams = Omit<IdeRouteParams, 'showSolution'> & { showSolution?: boolean };
export type IdeNavigation = (_: IdeNavigationParams) => string;
export type PartialIdeNavigation = (_: Partial<IdeNavigationParams>) => string;

export const ideLink: IdeNavigation = ({
  projectId,
  fileKey,
  snapshotId,
  showSolution = false,
  section,
}) => formatRoute(ideRoute)({ projectId, fileKey, snapshotId, section, showSolution });
